/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {deleteMemoriesApp} from '../api'

export const useMutationDeleteMemoriesApp = createReactQueryMutationHook('deleteMemoriesApp', deleteMemoriesApp)
